import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "../../../../adapter-vue";
import TUIChatEngine, { TUITranslateService, IMessageModel } from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import ReadStatus from "./read-status/index.vue";
import MessageQuote from "./message-quote/index.vue";
import Avatar from "../../../common/Avatar/index.vue";
import loadingIcon from "../../../../assets/icon/loading.png";
import { shallowCopyMessage } from "../../utils/utils";
import { isPC } from "../../../../utils/env";

interface IProps {
  messageItem: IMessageModel;
  content?: any;
  blinkMessageIDList?: string[];
}

interface IEmits {
  (e: 'resendMessage'): void;
  (e: 'blinkMessage', messageID: string): void;
  (e: 'setReadReciptPanelVisible', visible: boolean, message?: IMessageModel): void;
  // 下面的方法是 uniapp 专属
  (e: "scrollTo", scrollHeight: number): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-bubble',
  props: {
    messageItem: { default: () => ({} as IMessageModel) },
    content: { default: () => ({}) },
    blinkMessageIDList: { default: () => [] }
  },
  emits: ["resendMessage", "blinkMessage", "setReadReciptPanelVisible", "scrollTo"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'resendMessage'): void;
  (e: 'blinkMessage', messageID: string): void;
  (e: 'setReadReciptPanelVisible', visible: boolean, message?: IMessageModel): void;
  // 下面的方法是 uniapp 专属
  (e: "scrollTo", scrollHeight: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { messageItem: IMessageModel, content: any, blinkMessageIDList: string[] }





const TYPES = TUIChatEngine.TYPES;
const riskImageReplaceUrl =
  "https://web.sdk.qcloud.com/component/TUIKit/assets/has_risk_default.png";
const needLoadingIconMessageType = [
  TYPES.MSG_LOCATION,
  TYPES.MSG_TEXT,
  TYPES.MSG_CUSTOM,
  TYPES.MSG_MERGER,
  TYPES.MSG_FACE,
];

const { blinkMessageIDList, messageItem: message } = toRefs(props);

const isNoPadding = computed(() => {
  return [TYPES.MSG_IMAGE, TYPES.MSG_VIDEO].includes(message.value.type);
});

const riskContentText = computed<string>(() => {
  let content = TUITranslateService.t("TUIChat.涉及敏感内容") + ", ";
  if (message.value.flow === "out") {
    content += TUITranslateService.t("TUIChat.发送失败");
  } else {
    content += TUITranslateService.t(
      message.value.type === TYPES.MSG_AUDIO ? "TUIChat.无法收听" : "TUIChat.无法查看"
    );
  }
  return content;
});

const isBlink = computed(() => {
  if (message.value?.ID) {
    return blinkMessageIDList?.value?.includes(message.value.ID);
  }
  return false;
});

function resendMessage() {
  if (!message.value?.hasRiskContent) {
    emits("resendMessage");
  }
}

function blinkMessage(messageID: string) {
  emits("blinkMessage", messageID);
}

function scrollTo(scrollHeight: number) {
  emits("scrollTo", scrollHeight);
}

function openReadUserPanel() {
  emits("setReadReciptPanelVisible", true, message.value);
}

return { __sfc: true,emits, props, TYPES, riskImageReplaceUrl, needLoadingIconMessageType, blinkMessageIDList, message, isNoPadding, riskContentText, isBlink, resendMessage, blinkMessage, scrollTo, openReadUserPanel, Icon, ReadStatus, MessageQuote, Avatar, loadingIcon, shallowCopyMessage, isPC }
}

})